var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 62,
    viewBox: "0 0 83 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9222",
    "data-name": "Rectangle 9222",
    width: 29.373,
    height: 28.303,
    transform: "translate(0 0)",
    fill: "#1999f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18700",
    "data-name": "Group 18700",
    transform: "translate(-717 -708.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18693",
    "data-name": "Group 18693",
    transform: "translate(717 708.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8276",
    "data-name": "Rectangle 8276",
    transform: "translate(0 -0.259)",
    fill: "#fcfcfc",
    stroke: "#1999f5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 62,
    rx: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 61,
    rx: 30.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18692",
    "data-name": "Group 18692",
    transform: "translate(744.633 725.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18691",
    "data-name": "Group 18691",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31295",
    "data-name": "Path 31295",
    d: "M14.71,0,15.1.052c.021.008.042.017.063.023A2.4,2.4,0,0,1,16.721,1.3C17.3,2.4,17.862,3.5,18.429,4.6q.8,1.552,1.588,3.108a.144.144,0,0,0,.128.087c.518.064,1.037.128,1.555.2q2.706.36,5.411.725a2.625,2.625,0,0,1,.584.109,2.43,2.43,0,0,1,1.663,2.063,4.772,4.772,0,0,1,.015.517l-.036.253c-.028.092-.053.185-.083.276a2.624,2.624,0,0,1-.673,1.049c-.531.532-1.058,1.069-1.588,1.6q-1.675,1.684-3.353,3.365a.189.189,0,0,0-.062.192q.351,1.854.694,3.71c.2,1.1.4,2.208.609,3.311a2.371,2.371,0,0,1-.134,1.344,2.447,2.447,0,0,1-3.265,1.351c-.622-.281-1.224-.605-1.833-.914q-2.351-1.19-4.7-2.385a.13.13,0,0,0-.14.013q-3.141,1.709-6.282,3.417a2.356,2.356,0,0,1-1.854.2A2.4,2.4,0,0,1,5.04,26.678,2,2,0,0,1,4.9,25.669c.069-.475.124-.952.2-1.426q.455-2.929.92-5.857a.159.159,0,0,0-.057-.161q-2.369-2.24-4.735-4.483a7.384,7.384,0,0,1-.688-.7,2.412,2.412,0,0,1-.11-2.895A2.385,2.385,0,0,1,1.993,9.11c.523-.1,1.05-.18,1.576-.265Q6.347,8.4,9.127,7.957a.161.161,0,0,0,.138-.1q.946-2,1.9-3.993c.4-.836.792-1.675,1.2-2.506A2.377,2.377,0,0,1,14.161.04,5.1,5.1,0,0,1,14.71,0",
    transform: "translate(0 0.004)",
    fill: "#1999f5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponStar);
export default __webpack_public_path__ + "static/media/coupon-star.bbe0a0abdebdc899c364303b384610ad.svg";
export { ForwardRef as ReactComponent };